import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant, EstadosTablaComunConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

import * as FormGroups from './formGroups'

const EditarZonaModal = ({ handleClose, show, modalData, tipoTabla, onSuccess }) => {
  const __zariContext = React.useContext(ZariContext)

  const nombreTabla = React.useMemo(() => {
    return TiposTablaPersonalizadaConstant.__dictionary[tipoTabla].nombre
  }, [tipoTabla])

  const formInitialValues = React.useMemo(
    () => ({
      brevete: modalData.brevete ?? '',
      codigo: modalData.codigo ?? '',
      _idCentroCosto: modalData._idCentroCosto ?? '',
      _idListaPrecio: modalData._idListaPrecio ?? '',
      _idServicio: modalData._idServicio ?? '',
      _idSubServicio1: modalData._idSubServicio1 ?? '',
      cuentaContable: modalData.cuentaContable ?? '',
      cuentaContablePEN: modalData.cuentaContablePEN ?? '',
      cuentaContableUSD: modalData.cuentaContableUSD ?? '',
      nombreCuentaContablePEN: modalData.cuentaContablePEN ?? '',
      nombreCuentaContableUSD: modalData.cuentaContableUSD ?? '',
      estado: modalData.estado ?? EstadosTablaComunConstant.HABILITADO,
      flagECommerce: modalData.flagECommerce ?? false,
      flagPrincipal: modalData.flagPrincipal ?? false,
      marca: modalData.marca ?? '',
      nombre: modalData.nombre ?? '',
      medioPago: modalData.medioPago ?? '',
      numeroDocumentoIdentificacion: modalData.numeroDocumentoIdentificacion ?? '',
      placa: modalData.placa ?? '',
      porcentaje: modalData.porcentaje ?? '',
      texto: modalData.texto ?? '',
      tipoDocumentoIdentificacion: modalData.tipoDocumentoIdentificacion ?? '',
      razonSocial: modalData.razonSocial ?? '',
      valorSunat: modalData.valorSunat ?? '',
      tipoMedioPagoVenta: modalData.tipoMedioPagoVenta ?? '',
      tipo: tipoTabla
    }),
    [modalData, tipoTabla]
  )

  const submitHandler = async data => {
    if (modalData._id) {
      await TablasPersonalizadasService.actualizarxId(modalData._id, data)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha actualizado.')
          onSuccess()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      await TablasPersonalizadasService.nuevo(data)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha creado.')
          onSuccess()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  const modalBodyComponents = React.useCallback(
    ({ errors, isSubmitting, touched, values, setFieldValue }) => {
      switch (tipoTabla) {
        case TiposTablaPersonalizadaConstant.MEDIOSPAGOVENTAS:
          return (
            <>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.TipoMedioPagoVentaFormGroup
                iError={errors.tipoMedioPagoVenta}
                iTouched={touched.tipoMedioPagoVenta}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.CuentaContablePENFormGroup
                iError={errors.cuentaContablePEN}
                iTouched={touched.cuentaContablePEN}
                fIsSubmitting={isSubmitting}
                iValue={values.cuentaContablePEN}
                iReadonlyInfo={values.nombreCuentaContablePEN}
                setFieldValue={setFieldValue}
              />
              <FormGroups.CuentaContableUSDFormGroup
                iError={errors.cuentaContableUSD}
                iTouched={touched.cuentaContableUSD}
                fIsSubmitting={isSubmitting}
                iValue={values.cuentaContableUSD}
                iReadonlyInfo={values.nombreCuentaContableUSD}
                setFieldValue={setFieldValue}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.SUBMEDIOSPAGO:
          return (
            <>
              <FormGroups.MedioPagoFormGroup
                iError={errors.medioPago}
                iTouched={touched.medioPago}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.PRECIOXLISTA:
          return (
            <>
              <FormGroups.IdListaPrecioFormGroup
                iError={errors._idListaPrecio}
                iTouched={touched._idListaPrecio}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO1:
          return (
            <>
              <FormGroups.IdServicioFormGroup
                iError={errors._idServicio}
                iTouched={touched._idServicio}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO2:
          return (
            <>
              <FormGroups.IdServicioFormGroup
                iError={errors._idServicio}
                iTouched={touched._idServicio}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.IdSubServicio1FormGroup
                iError={errors._idSubServicio1}
                iTouched={touched._idSubServicio1}
                fIsSubmitting={isSubmitting}
                vIdServicio={values._idServicio}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.PLANTILLACOMENTARIOVENTA:
          return (
            <>
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.TextoFormGroup iError={errors.texto} iTouched={touched.texto} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaPersonalizadaConstant.AREASINTERNAS:
          return (
            <>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.MONEDA:
          return (
            <>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.ValorSunatFormGroup
                iError={errors.valorSunat}
                iTouched={touched.valorSunat}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.LISTAPRECIO:
        case TiposTablaPersonalizadaConstant.CHOFER:
        case TiposTablaPersonalizadaConstant.TECNICO:
        case TiposTablaPersonalizadaConstant.TALLERSERVICIO:
        case TiposTablaPersonalizadaConstant.ISLAGRIFO:
          return (
            <>
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA:
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLEVENTA:
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLEEXISTENCIA:
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLEINVENTARIO:
          return (
            <>
              <FormGroups.CuentaContableFormGroup
                iError={errors.cuentaContable}
                iTouched={touched.cuentaContable}
                fIsSubmitting={isSubmitting}
                iValue={values.cuentaContable}
                iReadonlyInfo={values.cuentaContable}
                setFieldValue={setFieldValue}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.CONDUCTOR:
          return (
            <>
              <FormGroups.BreveteFormGroup
                iError={errors.brevete}
                iTouched={touched.brevete}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.TipoDocumentoIdentificacionFormGroup
                iError={errors.tipoDocumentoIdentificacion}
                iTouched={touched.tipoDocumentoIdentificacion}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NumeroDocumentoIdentificacionFormGroup
                iError={errors.numeroDocumentoIdentificacion}
                iTouched={touched.numeroDocumentoIdentificacion}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.PLACA:
          return (
            <>
              <FormGroups.MarcaFormGroup iError={errors.marca} iTouched={touched.marca} fIsSubmitting={isSubmitting} />
              <FormGroups.PlacaFormGroup iError={errors.placa} iTouched={touched.placa} fIsSubmitting={isSubmitting} />
            </>
          )
        case TiposTablaPersonalizadaConstant.SUSTRACCIONVENTAS:
          return (
            <>
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.PorcentajeFormGroup
                iError={errors.porcentaje}
                iTouched={touched.porcentaje}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.TRANSPORTISTA:
          return (
            <>
              <FormGroups.TipoDocumentoIdentificacionFormGroup
                iError={errors.tipoDocumentoIdentificacion}
                iTouched={touched.tipoDocumentoIdentificacion}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NumeroDocumentoIdentificacionFormGroup
                iError={errors.numeroDocumentoIdentificacion}
                iTouched={touched.numeroDocumentoIdentificacion}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.RazonSocialFormGroup
                iError={errors.razonSocial}
                iTouched={touched.razonSocial}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        case TiposTablaPersonalizadaConstant.OFICINA:
          return (
            <>
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.CentroCostoFormGroup
                iError={errors._idCentroCosto}
                iTouched={touched._idCentroCosto}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
        default:
          return (
            <>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
            </>
          )
      }
    },
    [tipoTabla]
  )

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>{`${modalData._id ? 'EDITAR' : 'CREAR'} - ${nombreTabla}`}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              {modalBodyComponents({ errors, isSubmitting, touched, values, setFieldValue })}
              <FormGroups.EstadoFormGroup
                iError={errors.estado}
                iTouched={touched.estado}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>{modalData._id ? 'Actualizar' : 'Crear'}</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarZonaModal
